// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","modal":"modal-159TY","modal_mobileFullScreen":"modal_mobileFullScreen-3AZhg","close":"close-_C9dh"};